module.exports = {"src":["audio.ogg","audio.mp3"],"sprite":{"barkDucks":[0,2403.265306122449],"champ":[4000,9639.183673469388],"drzwi":[15000,2324.897959183673],"gunSound":[19000,3813.8775510204077],"laugh":[24000,1368.0045351473923],"loserSound":[27000,4336.326530612244],"music":[33000,114155.10204081633,true],"ohYeah":[149000,1071.020408163264],"quacking":[152000,6817.95918367348,true],"quak":[160000,783.6734693877645],"sniff":[162000,1985.306122448975,true],"thud":[165000,548.5714285714209]}}


//////////////////
// WEBPACK FOOTER
// ./dist/audio.json
// module id = 622
// module chunks = 0